import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { CategoryNavItem } from "../../types";
import "./style.scss";

const LeadershipIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="36"
    viewBox="0 0 42 36"
    fill="none"
  >
    <path
      d="M20.9597 1.55249L1.39062 35.4473H40.5288L20.9597 1.55249ZM20.9597 8.84673L5.60185 35.4473H36.3176L20.9597 8.84673ZM20.9597 16.141L9.81308 35.4473H32.1064L20.9597 16.141ZM20.9597 23.4352L14.025 35.4473H27.8945L20.9597 23.4352ZM20.9597 30.7295L18.2362 35.4473H23.6832L20.9597 30.7295Z"
      stroke="currentColor"
      strokeWidth="1.04"
    />
  </svg>
);

const OrganizationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="37"
    height="37"
    viewBox="0 0 37 37"
    fill="none"
  >
    <path
      d="M36.3906 18.5C36.3906 28.1652 28.5558 36 18.8906 36C9.22542 36 1.39062 28.1652 1.39062 18.5M36.3906 18.5C36.3906 8.8348 28.5558 0.999999 18.8906 0.999999C9.22542 0.999999 1.39062 8.8348 1.39062 18.5M36.3906 18.5C36.3906 24.4881 28.5558 29.3422 18.8906 29.3422C9.22542 29.3422 1.39062 24.4881 1.39062 18.5M36.3906 18.5C36.3906 12.5119 28.5558 7.65778 18.8906 7.65778C9.22542 7.65778 1.39062 12.5119 1.39062 18.5M36.3906 18.5C36.3906 20.811 28.5558 22.6844 18.8906 22.6844C9.22542 22.6844 1.39062 20.811 1.39062 18.5M36.3906 18.5C36.3906 16.189 28.5558 14.3156 18.8906 14.3156C9.22542 14.3156 1.39062 16.189 1.39062 18.5"
      stroke="currentColor"
      strokeWidth="1.12"
    />
  </svg>
);

const TeamIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="37"
    height="37"
    viewBox="0 0 37 37"
    fill="none"
  >
    <path
      d="M35.819 35.7139H1.39062M35.819 35.7139V1.28549H1.39062V35.7139M35.819 35.7139L1.39062 1.2862M35.819 35.7139L31.5155 5.58975L1.39062 1.2862M35.819 35.7139L27.2119 9.89328L1.39062 1.2862M35.819 35.7139L22.9084 14.1968L1.39062 1.2862M35.819 35.7139L5.69418 31.411L1.39062 1.2862M35.819 35.7139L9.99771 27.1075L1.39062 1.2862M35.819 35.7139L14.3013 22.8039L1.39062 1.2862M1.39062 35.7139V1.2862"
      stroke="currentColor"
      strokeWidth="1.029"
    />
  </svg>
);

export const CATEGORY_ICONS: Record<CategoryNavItem, React.ReactElement> = {
  organization: <OrganizationIcon />,
  team: <TeamIcon />,
  leadership: <LeadershipIcon />,
};

interface ChallengeRowProps {
  id: number;
  title: string;
  percentage: number | string;
  type: CategoryNavItem;
  onHover?: (id?: ChallengeRowProps["id"]) => void;
}

export const ChallengeRow: FC<ChallengeRowProps> = ({
  id,
  title,
  percentage,
  type,
  onHover,
}) => {
  const { t } = useTranslation();

  const TITLE_TEXTS: Record<CategoryNavItem, string> = {
    organization: t(
      "frontend.futurebilityCockpit.challengeRow.title.organization",
      "Organization"
    ),
    team: t("frontend.futurebilityCockpit.challengeRow.title.team", "Team"),
    leadership: t(
      "frontend.futurebilityCockpit.challengeRow.title.leadership",
      "Leadership"
    ),
  };

  const handleMouseEnter = useCallback(() => {
    onHover?.(id);
  }, [id, onHover]);

  const handleMouseLeave = useCallback(() => {
    onHover?.();
  }, [onHover]);

  return (
    <div
      className="challenge-row"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="type-title">{TITLE_TEXTS[type]}</div>
      <div className="icon">{CATEGORY_ICONS[type]}</div>
      <div className="main-title">{title}</div>
      <div className="percentage-circle">{percentage}%</div>
    </div>
  );
};

export default ChallengeRow;
